import { render, staticRenderFns } from "./MobileIndexPage.vue?vue&type=template&id=3182fdb6&scoped=true"
import script from "./MobileIndexPage.vue?vue&type=script&lang=js"
export * from "./MobileIndexPage.vue?vue&type=script&lang=js"
import style0 from "./MobileIndexPage.vue?vue&type=style&index=0&id=3182fdb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3182fdb6",
  null
  
)

export default component.exports